export default theme => ({
  panel: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: 10,
    overflow: 'auto',
    height: '100%',
    backgroundColor: '#f5f5f5',
  },
  totalsCard: {
    border: '1px solid #ccc',
    borderRadius: 4,
    padding: '8px 10px',
    backgroundColor: '#fff',
  },
  totalsLabel: {
    fontSize: 11,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    color: '#777',
  },
  totalsValue: {
    fontFamily: 'monospace',
    fontSize: 22,
    margin: '2px 0',
  },
  totalsSub: {
    fontFamily: 'monospace',
    fontSize: 12,
    color: '#777',
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: '5px 8px',
    marginBottom: 3,
    border: '1px solid #ccc',
    borderRadius: 4,
    backgroundColor: '#fff',
    cursor: 'pointer',
    textAlign: 'left',
  },
  listItemSelected: {
    borderColor: '#333',
    backgroundColor: '#eee',
  },
  swatch: {
    width: 10,
    height: 10,
    borderRadius: '50%',
    marginRight: 8,
    flexShrink: 0,
    display: 'inline-block',
  },
  code: {
    fontFamily: 'monospace',
    fontSize: 13,
  },
  editCard: {
    border: '1px solid #ccc',
    borderRadius: 4,
    padding: '8px 10px',
    backgroundColor: '#fff',
  },
  select: {
    width: '100%',
    marginBottom: 6,
    '& .MuiFormControl-root': {
      height: 32,
    },
    '& .MuiInputLabel-root': {
      fontSize: 11,
      color: '#777',
      marginBottom: 0,
      lineHeight: 1.4,
    },
    '& .MuiOutlinedInput-input, & .MuiSelect-select': {
      padding: '6px 10px',
      fontSize: 13,
      minHeight: 'auto',
    },
    '& .MuiSelect-selectMenu': {
      minHeight: 'auto',
    },
    '& svg': {
      width: 18,
      height: 18,
    },
  },
  helperText: {
    fontSize: 11,
    color: '#777',
    marginBottom: 6,
  },
  summary: {
    fontFamily: 'monospace',
    fontSize: 12,
  },
  removeLink: {
    marginTop: 6,
    fontSize: 12,
    color: '#777',
    textDecoration: 'underline',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
  },
});
